import axios from "axios";
import { TTP_API_URL } from "../config";

const ENDPOINT_BASE_URL = `${TTP_API_URL}/team/croissance`;

export const getReviewData = ({ token, organizationId, start, filters }) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/review`;
  let params = {
    access_token: token,
    organizationId,
    year: filters.year,
    start,
    limit: filters.pageSize,
    bu: filters.bu,
    zone: filters.zone,
    partner: filters.partner,
    collaborator: filters.collaborator,
    collaboratorRole: filters.role,
    clientGroup: filters.clientGroup,
    searchWord: filters.keyWord,
  };

  return axios.get(requestUrl, { params });
};

export const getNewClients = ({ token, organizationId, start, filters }) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/new-clients`;
  let params = {
    access_token: token,
    organizationId,
    year: filters.year,
    start,
    limit: filters.pageSize,
    bu: filters.bu,
    zone: filters.zone,
    partner: filters.partner,
    collaborator: filters.collaborator,
    collaboratorRole: filters.role,
    clientGroup: filters.clientGroup,
    searchWord: filters.keyWord,
    reminderType: filters.reminderType,
  };

  return axios.get(requestUrl, { params });
};

export const exportNewClients = async ({ token, organizationId, filters }) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/new-clients/export`;
  let params = {
    access_token: token,
    organizationId,
    year: filters.year,
    bu: filters.bu,
    zone: filters.zone,
    partner: filters.partner,
    collaborator: filters.collaborator,
    collaboratorRole: filters.role,
    clientGroup: filters.clientGroup,
    searchWord: filters.keyWord,
    reminderType: filters.reminderType,
  };

  const response = await axios.get(requestUrl, {
    params,
    responseType: "blob",
    headers: { Accept: "application/vnd.ms-excel" },
  });

  const url = window.URL.createObjectURL(
    new Blob([response.data], { type: response.data.type })
  );
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `clients-entrants-${filters.year}.xlsx`);
  document.body.appendChild(link);
  link.click();

  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
};

export const saveNewClients = ({ token, organizationId, items }) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/new-clients`;

  const formData = new FormData();
  formData.append("access_token", token);
  formData.append("organizationId", organizationId);
  formData.append("items", JSON.stringify(items));

  return axios.post(requestUrl, formData);
};

export const getNewClientsCanals = ({token, organizationId}) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/new-clients/canals`;
  let params = {
    access_token: token,
    organizationId,
  };

  return axios.get(requestUrl, { params });
}

export const getOldClients = ({token, organizationId, start, filters}) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/old-clients`;
  let params = {
    access_token: token,
    organizationId,
    year: filters.year,
    start,
    limit: filters.pageSize,
    bu: filters.bu,
    zone: filters.zone,
    partner: filters.partner,
    collaborator: filters.collaborator,
    collaboratorRole: filters.role,
    clientGroup: filters.clientGroup,
    searchWord: filters.keyWord,
    annualFinancialImpact: JSON.stringify({
      yearN: filters.yearN,
      yearNMinus1: filters.yearNMinus1,
      yearNPlus1: filters.yearNPlus1,
      impactN: filters.impactN,
    }),
  };

  return axios.get(requestUrl, { params });
};

export const exportOldClients = async ({ token, organizationId, filters }) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/old-clients/export`;
  let params = {
    access_token: token,
    organizationId,
    year: filters.year,
    bu: filters.bu,
    zone: filters.zone,
    partner: filters.partner,
    collaborator: filters.collaborator,
    collaboratorRole: filters.role,
    clientGroup: filters.clientGroup,
    searchWord: filters.keyWord,
    annualFinancialImpact: JSON.stringify({
      yearN: filters.yearN,
      yearNMinus1: filters.yearNMinus1,
      yearNPlus1: filters.yearNPlus1,
      impactN: filters.impactN,
    }),
  };

  const response = await axios.get(requestUrl, {
    params,
    responseType: "blob",
    headers: { Accept: "application/vnd.ms-excel" },
  });

  const url = window.URL.createObjectURL(
    new Blob([response.data], { type: response.data.type })
  );
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `clients-sortants-${filters.year}.xlsx`);
  document.body.appendChild(link);
  link.click();

  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
};

export const saveOldClients = ({ token, organizationId, items }) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/old-clients`;

  const formData = new FormData();
  formData.append("access_token", token);
  formData.append("organizationId", organizationId);
  formData.append("items", JSON.stringify(items));

  return axios.post(requestUrl, formData);
};

export const getRiskyClients = ({ token, organizationId, start, filters }) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/risky-clients`;
  let params = {
    access_token: token,
    organizationId,
    year: filters.year,
    start,
    limit: filters.pageSize,
    bu: filters.bu,
    zone: filters.zone,
    partner: filters.partner,
    collaborator: filters.collaborator,
    collaboratorRole: filters.role,
    clientGroup: filters.clientGroup,
    searchWord: filters.keyWord,
  };

  return axios.get(requestUrl, { params });
};

export const getClientsToMonitor = ({token, organizationId, start, filters}) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/clients-to-monitor`;
  let params = {
    access_token: token,
    organizationId,
    year: filters.year,
    start,
    limit: filters.pageSize,
    bu: filters.bu,
    zone: filters.zone,
    partner: filters.partner,
    collaborator: filters.collaborator,
    collaboratorRole: filters.role,
    clientGroup: filters.clientGroup,
    searchWord: filters.keyWord,
  };

  return axios.get(requestUrl, { params });
}

export const getLeavingClients = ({token, organizationId, start, filters}) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/leaving-clients`;
  let params = {
    access_token: token,
    organizationId,
    year: filters.year,
    start,
    limit: filters.pageSize,
    bu: filters.bu,
    zone: filters.zone,
    partner: filters.partner,
    collaborator: filters.collaborator,
    collaboratorRole: filters.role,
    clientGroup: filters.clientGroup,
    searchWord: filters.keyWord,
  };

  return axios.get(requestUrl, { params });
}

export const saveRiskyClients = ({token, organizationId, items}) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/risky-clients`;

  const formData = new FormData();
  formData.append("access_token", token);
  formData.append("organizationId", organizationId);
  formData.append("items", JSON.stringify(items));

  return axios.post(requestUrl, formData);
};

export const getProspectClients = ({ token, organizationId, start, filters }) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/prospect-clients`;
  let params = {
    access_token: token,
    organizationId,
    year: filters.year,
    start,
    limit: filters.pageSize,
    bu: filters.bu,
    zone: filters.zone,
    partner: filters.partner,
    collaborator: filters.collaborator,
    collaboratorRole: filters.role,
    clientGroup: filters.clientGroup,
    searchWord: filters.keyWord
  };

  return axios.get(requestUrl, { params });
};

export const saveProspectClients = ({ token, organizationId, items }) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/prospect-clients`;

  const formData = new FormData();
  formData.append("access_token", token);
  formData.append("organizationId", organizationId);
  formData.append("items", JSON.stringify(items));

  return axios.post(requestUrl, formData);
};

export const deleteProspectClient = ({ token, organizationId, prospectClientId }) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/prospect-clients/delete`;

  const formData = new FormData();
  formData.append("access_token", token);
  formData.append("organizationId", organizationId);
  formData.append("prospectClientId", prospectClientId);

  return axios.post(requestUrl, formData);
};

export const getClientEntryChannels = ({token, organizationId}) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/croissance-channels`;
  let params = {
    access_token: token,
    organizationId,
  };

  return axios.get(requestUrl, { params });
}

export const getProspectClientsEmails = ({token, organizationId}) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/prospect-clients-emails`;
  let params = {
    access_token: token,
    organizationId,
  };

  return axios.get(requestUrl, { params });
}

export const markProspectClientsEmailAsIgnored = ({token, emailId}) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/prospect-clients-emails/ignore`;
  const formData = new FormData();
  formData.append("access_token", token);
  formData.append("emailId", emailId);

  return axios.post(requestUrl, formData);
}

export const getProspectClientsEmailsFromOutlook = ({token, organizationId}) => {
  const requestUrl = `${ENDPOINT_BASE_URL}/prospects/outlook-emails`;
  let params = {
    access_token: token,
    organizationId,
  };

  return axios.get(requestUrl, { params });
}
